import React from "react";
import { useTranslation } from "react-i18next";
import CustomReactPlayer from "../../CustomReactPlayer";

export const InterproximalReduction = () => {
  const { t: _t } = useTranslation();
  return (
    <>
      <img src={require("../../assets/3_interproximal-reduction/1.jpg")} alt="" />
      <h2>{_t("Описание методики:")}</h2>
      <p>
        {_t(
          "Сепарация (IPR, Interproximal reduction, межапроксимальная редукция) – это процедура, предусматривающая искусственное разобщение расположенных рядом зубов путём снятия тонкого слоя эмали на их апроксимальных поверхностях. Для проведения данной процедуры используются абразивные штрипсы, сепарационные ручные пилы или абразивные диски для наконечника. Показаниями к проведению процедуры сепарации являются легкая или умеренная скученность, а так же черные треугольники между передними зубами. Как и в других ортодонтических методиках, сепарации применяются для компенсации места в случае его дефицита. Допускается удаление около 50% эмали с апроксимальной стороны зуба. Это не вызывает проблем с зубами или пародонтом. Можно получить 2,5 мм от сепарации пяти передних контактов и 6,4 мм от восьми задних контактов. Рекомендовано удалять не более 0,5 - 0,75 мм с каждой апроксимальной поверхности передних зубов. Данная процедура является обязательной для выполнения в случаях, где это предусмотрено планом ортодонтического лечения. IPR так же можно использовать для улучшения эстетики передних зубов в случаях, когда зубная дуга выровнена и в результате образовались «черные треугольники». Они могут быть удалены с помощью сепарации передних зубов.",
        )}
      </p>
      <img src={require("../../assets/3_interproximal-reduction/2.jpg")} alt="" />
      <h2>{_t("Протокол осуществления сепараций:")}</h2>
      <p>
        {_t(
          "Для осуществления межапроксимальной редукции в случаях дефицита места на челюсти для нормального положения зубов необходимо применить протокол:",
        )}
      </p>
      <p>
        {_t("- изучить план ортодонтического лечения;")}
        <br /> {_t("- определить места и толщину сепараций;")}
        <br /> {_t("- подготовить алмазные штрипсы разных толщин;")}
        <br />
        {_t(
          "- продеть тонкий алмазный штрипс между зубов и плавными, возвратно-поступательными движениями произвести пришлифовывание апроксимальных поверхностей до момента, когда штрипс будет проходить свободно;",
        )}
        <br /> {_t("- подготовить алмазные штрипсы разных толщин;")}
        <br /> {_t("- определить места и толщину сепараций;")}
        <br /> {_t("- отполировать апроксимальные поверхности полировочным штрипсом.")}
      </p>
      <p>
        {_t(
          "На протяжении всего лечения необходим контроль межапрокси-мальных контактов и своевременное пришлифовывание апрокси¬мальных поверхностей. Если зубы не приобрели запланированное на данном этапе положение, а зубная нить проходит между ними с трудом – необходимо повторить процедуру сепарации. Контроль межапроксимальных контактов необходимо производить через каждые три-четыре элайнера в системе.",
        )}
      </p>
      <CustomReactPlayer
        src={require("../../assets/3_interproximal-reduction/video_1.mp4")}
        poster={require("../../assets/3_interproximal-reduction/videо_1.jpg")}
      />
    </>
  );
};
